import React, { useState } from 'react';



import callIcon from './images/call_icon.png';
import createIcon from './images/create_icon.png';
import feedbackIcon from './images/feedback_icon.png';
import listingIcon from './images/listing_icon.png';
import offerIcon from './images/offer_icon.png';
import progressIcon from './images/progress_icon.png';
import searchIcon from './images/search_icon.png';
import submitIcon from './images/submit_icon.png';
import verifiedIcon from './images/verified_icon.png';

import css from './SectionProcess.module.css';
import { FormattedMessage } from 'react-intl';


const SectionProcess = props => {

    const [currentTab, setCurrentTab] = useState('jobMarketplace');
    return (
        <div className={css.root}>


            <p className={css.title}>
                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.title" />
            </p>



            <div className={css.panelWrapper}>

                <div className={css.horizontalWrapper}>
                    <div onClick={() => setCurrentTab("jobMarketplace")}>
                        <p className={currentTab === "jobMarketplace" ? css.subtitleActive : css.subtitle} >
                            <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.title" />
                        </p>

                        {currentTab === "jobMarketplace"
                            ? <div className={css.line} /> : null}

                    </div>

                    <div onClick={() => setCurrentTab("createJob")}>
                        <p className={currentTab === "createJob" ? css.subtitleActive : css.subtitle}>
                            <FormattedMessage id="LandingProfessionalsPage.SectionProcess.create.title" />
                        </p>

                        {currentTab === "createJob"
                            ? <div className={css.line} /> : null}
                    </div>
                </div>

                {currentTab === 'jobMarketplace' ?
                    <div className={css.panelWrapped}>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={verifiedIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step1.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step1.info" />
                            </p>
                        </div>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={listingIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step2.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step2.info" />
                            </p>
                        </div>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={searchIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step3.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step3.info" />
                            </p>
                        </div>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={submitIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step4.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step4.info" />
                            </p>
                        </div>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={callIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step5.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step5.info" />
                            </p>
                        </div>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={progressIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step6.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step6.info" />
                            </p>
                        </div>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={feedbackIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step7.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step7.info" />
                            </p>
                        </div>
                    </div>
                    :
                    <div className={css.panelWrapped}>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={verifiedIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.create.step1.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.create.step1.info" />
                            </p>
                        </div>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={createIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.create.step2.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.create.step2.info" />
                            </p>
                        </div>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={offerIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.create.step3.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.create.step3.info" />
                            </p>
                        </div>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={callIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.create.step4.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.create.step4.info" />
                            </p>
                        </div>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={progressIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.create.step5.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.create.step5.info" />
                            </p>
                        </div>

                        <div className={css.panelItem}>
                            <img className={css.panelItemIcon} src={feedbackIcon} />
                            <p className={css.panelItemTitle}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step6.title" />
                            </p>
                            <p className={css.panelItemInfo}>
                                <FormattedMessage id="LandingProfessionalsPage.SectionProcess.marketplace.step6.info" />
                            </p>
                        </div>
                    </div>
                }
            </div>
        </div>

    );
};

export default SectionProcess;
